<div *ngIf="companyBattleQBs.length > 0" class="head-to-head-dashboard">
  <!-- regular grid charts container -->
  <div class="tw-grid tw-grid-cols-1 @lg:tw-grid-cols-2 tw-gap-6 tw-mb-4">
    <div
      class="tw-bg-transparent dark:tw-bg-gray-800 tw-rounded-lg tw-p-3 @xxl:tw-p-6 tw-min-h-[300px] tw-flex tw-items-center tw-justify-center">
      <app-reports-headcount-comparison
        [quickBuilds]="companyBattleQBs"
        [reportTarget]="reportTarget"
        [boxShadow]="false"
        [dateFrom]="dateRangeStrings[0]"
        [dateTo]="dateRangeStrings[1]"
        class="tw-w-full"
        [selectedHeadcountChartValueType]="
          chartConfigs['headcount-comparison']?.selectedHeadcountChartValueType
        "
        [selectedHeadcountChartType]="chartConfigs['headcount-comparison']?.selectedHeadcountChartType"
        (configChange)="onChartConfigChange('headcount-comparison', $event)"></app-reports-headcount-comparison>
    </div>
    <div
      class="tw-bg-transparent dark:tw-bg-gray-800 tw-rounded-lg tw-p-3 @xxl:tw-p-6 tw-min-h-[300px] tw-flex tw-items-center tw-justify-center">
      <app-reports-top-values-comparison
        tourAnchor="company-chart"
        [quickBuilds]="companyBattleQBs"
        [reportTarget]="reportTarget"
        [boxShadow]="false"
        class="tw-w-full"
        [selectedBreakdownBy]="chartConfigs['top-values-comparison']?.selectedBreakdownBy"
        [selectedValueType]="chartConfigs['top-values-comparison']?.selectedValueType"
        [selectedHeadcountChartType]="chartConfigs['top-values-comparison']?.selectedHeadcountChartType"
        (configChange)="onChartConfigChange('top-values-comparison', $event)"></app-reports-top-values-comparison>
    </div>
    <div
      class="tw-bg-transparent dark:tw-bg-gray-800 tw-rounded-lg tw-p-3 @xxl:tw-p-6 tw-min-h-[300px] tw-flex tw-items-center tw-justify-center">
      <app-reports-jobs-moves-comparison
        [quickBuilds]="companyBattleQBs"
        [reportTarget]="reportTarget"
        [dateFrom]="dateRangeStrings[0]"
        [dateTo]="dateRangeStrings[1]"
        [boxShadow]="false"
        class="tw-w-full"
        [selectedValueType]="chartConfigs['job-moves-comparison']?.selectedValueType"
        [selectedSeries]="chartConfigs['job-moves-comparison']?.selectedSeries"
        (configChange)="onChartConfigChange('job-moves-comparison', $event)"></app-reports-jobs-moves-comparison>
    </div>
    <div
      class="tw-bg-gray-800 tw-rounded-lg tw-p-3 @xxl:tw-p-6 tw-min-h-[300px] tw-flex tw-items-center tw-justify-center">
      <app-reports-historical-tenure-comparison
        [quickBuilds]="companyBattleQBs"
        [reportTarget]="reportTarget"
        [dateFrom]="dateRangeStrings[0]"
        [dateTo]="dateRangeStrings[1]"
        [boxShadow]="false"
        class="tw-w-full"
        [selectedTenureType]="chartConfigs['historical-tenure-comparison']?.selectedTenureType"
        (configChange)="onChartConfigChange('historical-tenure-comparison', $event)"></app-reports-historical-tenure-comparison>
    </div>
    <div
      class="tw-bg-gray-800 tw-rounded-lg tw-p-3 @xxl:tw-p-6 tw-min-h-[300px] tw-flex tw-items-center tw-justify-center">
      <app-reports-tenure-cohort-comparison
        [quickBuilds]="companyBattleQBs"
        [reportTarget]="reportTarget"
        [boxShadow]="false"
        class="tw-w-full"
        [selectedCohortSize]="chartConfigs['tenure-cohort-comparison']?.selectedCohortSize"
        (configChange)="onChartConfigChange('tenure-cohort-comparison', $event)"></app-reports-tenure-cohort-comparison>
    </div>
  </div>
  <div
    class="tw-bg-transparent dark:tw-bg-gray-800 tw-rounded-lg tw-p-3 @xxl:tw-p-6 tw-flex tw-items-center tw-overflow-x-auto">
    <div class="tw-min-w-[720px] tw-w-full tw-h-full">
      <app-prev-next-flow-comparison
        [quickBuilds]="companyBattleQBs"
        [reportTarget]="reportTarget"
        [dateFrom]="dateRangeStrings[0]"
        [dateTo]="dateRangeStrings[1]"
        [boxShadow]="false"
        class="tw-w-full tw-h-full"
        [selectedSeries]="chartConfigs['talent-flow-comparison']?.selectedSeries"
        (configChange)="onChartConfigChange('talent-flow-comparison', $event)"></app-prev-next-flow-comparison>
    </div>
  </div>
</div>
